import Settings from '@/pages/Settings';

export default [
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: {
      requiresAuth: true,
      permissions: ['perm_view_setting'],
    },
  },
];
